import { type Level } from '@/lib/types';
import { useContext, useState } from 'react';
import LevelProgressNotes from './LevelProgressNotes';
import LevelProgressCoachComments from './LevelProgressCoachComments';
import AttachmentDialogTitle from './AttachmentDialogTitle';
import LevelProof from './LevelProof';
import AtachmentsButton from './AttachmentsButton';
import AttachmentDialog from './AttachmentDialog';
import useMarkCoachCommentsAsRead from './useMarkCoachCommentsAsRead';
import PortfolioItemCloseBlockingContext from '@/components/ChallengePortfolio/NormalView/portfolio-item/PortfolioItemCloseBlockingContext';

type LevelAttachmentProps = {
  level: Level;
};

const LevelAttachments = ({ level }: LevelAttachmentProps) => {
  const markCoachCommentsAsRead = useMarkCoachCommentsAsRead(level.id);
  const [dialogOpen, setDialogOpen] = useState(false);

  const { isPortfolioItemCloseBlocked } = useContext(
    PortfolioItemCloseBlockingContext,
  );

  return (
    <>
      <AtachmentsButton
        levelId={level.id}
        onClick={() => {
          setDialogOpen(true);

          markCoachCommentsAsRead();
        }}
      />
      <AttachmentDialog
        open={dialogOpen}
        onClose={(_, reason) => {
          if (
            isPortfolioItemCloseBlocked &&
            ['escapeKeyDown', 'backdropClick'].includes(reason)
          ) {
            return;
          }

          setDialogOpen(false);
        }}
      >
        <AttachmentDialogTitle
          level={level}
          onCloseDialog={() => setDialogOpen(false)}
        />
        <LevelProof levelId={level.id} />
        <LevelProgressNotes level={level} />
        <LevelProgressCoachComments level={level} />
      </AttachmentDialog>
    </>
  );
};

export default LevelAttachments;
